import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

export const loansFields: FieldInterface[] = [
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'period',
    originKey: 'period',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'monthlyPayment',
    originKey: 'monthly_payment',
    type: FIELD_TYPES.integer,
  },
  {
    key: 'warnings',
    originKey: 'warnings',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
]

export const loansRelations: RelationInterface[] = []
